import * as React from 'react'
import * as ReactDOM from 'react-dom'
import FilterHolder from './components/FilterHolder'
import { ProductList as ProductListModel } from 'src/models/product'
import { onSnapshot, applySnapshot } from 'mobx-state-tree'
import buildUrlFromOptions from './utils/buildUrlFromOptions'
import trans from './utils/translations'

declare var window: any
declare var document: any

if (window.appTranslations) {
    //    trans.setTranslations(JSON.parse(window.appTranslations))
    trans.setTranslations(window.appTranslations)
}

let initalState: any = {}
if (window.productOverviewState) {
    const productOverviewState = JSON.parse(atob(window.productOverviewState))
    if (ProductListModel.is(productOverviewState)) {
        initalState = productOverviewState
    } else {
        // Still parse it on fail to get the error
        try {
            ProductListModel.create(productOverviewState)
        } catch (e) {
            console.error(e, productOverviewState)
        }
    }
}

const productList = (window.productList = ProductListModel.create(initalState))

let latestPopState: any

window.onpopstate = (state: any) => {
    latestPopState = state.state
    if (ProductListModel.is(latestPopState)) {
        applySnapshot(productList, state.state)
    }
}

function renderFilterApp() {
    if (document.getElementById('productOverview')) {
        ReactDOM.render(<FilterHolder productList={productList} />, document.getElementById(
            'productOverview'
        ) as HTMLElement)
    }
}

renderFilterApp()

onSnapshot(productList, snapshot => {
    if (JSON.stringify(snapshot) == JSON.stringify(latestPopState)) return
    const url = buildUrlFromOptions({
        page: snapshot.page,
        sort: snapshot.sort,
        selectedCategories: snapshot.filterCategories.filter(s => s.selected).map(s => s.id),
        selectedSpecifications: snapshot.filterSpecifications.filter(s => s.selected).map(s => s.id),
        selectedBedrooms: snapshot.filterBedrooms.filter(s => s.selected).map(s => s.id),
        selectedLocations: snapshot.filterLocations.filter(s => s.selected).map(s => s.id),
        selectedBrands: snapshot.filterBrands.filter(s => s.selected).map(s => s.id),
        selectedTypes: snapshot.filterTypes.filter(s => s.selected).map(s => s.id),
        minprice: snapshot.filterMinPrice,
        maxprice: snapshot.filterMaxPrice,
        mindimension: snapshot.filterMinDimension,
        maxdimension: snapshot.filterMaxDimension,
        currentLanguageId: snapshot.currentLanguageId,
        currentPageId: snapshot.currentPageId,
    })
    history.pushState(snapshot, '', document.location.pathname + (url ? '?' + url : ''))
})

declare var module: any
if (module.hot) {
    module.hot.accept('./components/FilterHolder', () => {
        renderFilterApp()
    })
}



// WEBPACK FOOTER //
// ./react/src/index.tsx